<template>
  <CButton @click="update">
    <CIcon name="box-trolley"/>
    <CPickingStatusIcon :status/>
  </CButton>
</template>

<script setup lang="ts">
  import Modal from '@/general/utils/Modal';
  import CIcon from '@/shared/components/CIcon.vue';
  import CButton from '@/shared/components/buttons/CButton.vue';
  import JobContext from '../models/JobContext';
  import JobItem from '../models/JobItem';
  import CPickingStatusIcon from './CPickingStatusIcon.vue';

  const PickingStatusModal = () => import('../modals/PickingStatusModal.vue');

  const props = defineProps<{
    item: JobItem;
    context: JobContext;
  }>();

  const status = defineModel();

  async function update() {
    status.value = await Modal.openAndWait(PickingStatusModal, { item: props.item, status: status.value });
  }
</script>